import { usePaginationWithComponent } from "hooks/usePaginationWithComponent";
import {
  createContext,
  useCallback,
  useContext,
  useEffect,
  useState,
} from "react";
import { getRequest } from "services/api";
import Swal from "sweetalert2";
import { LIMIT_DATA_PER_PAGE } from "utils/constants";
import { buildQueryString } from "utils/queryHelpers";

const CustomerContext = createContext();

export const CustomerProvider = ({ children }) => {
  const [customers, setCustomers] = useState({
    data: [],
    pagination: null,
    error: null,
    loading: false,
  });

  const [filterOptions, setFilterOptions] = useState({
    search: "",
    currentPage: 1,
    totalPages: 1,
  });

  const queryString = buildQueryString({
    search: filterOptions.search || "",
    page: filterOptions.currentPage,
    limit: LIMIT_DATA_PER_PAGE,
  });

  // const handleSearch = (e) => {
  //   if (e.key === "Enter") {
  //     console.log("search", e.target.value);
  //     setFilterOptions((prevState) => ({
  //       ...prevState,
  //       search: e.target.value,
  //     }));
  //   }
  // };

  // const handleSearch = (e) => {
  //   if (e.key === "Enter") {
  //     if (!e.target.value.trim()) {
  //       // Jika input kosong, tampilkan SweetAlert2
  //       Swal.fire({
  //         icon: "warning",
  //         title: "Invalid Search",
  //         text: "Search input cannot be empty!",
  //       }).then(() => {
  //         // Reset state setelah menekan "OK"
  //         setFilterOptions((prevState) => ({
  //           ...prevState,
  //           search: "", // Reset pencarian
  //         }));

  //         // Refetch data tanpa filter pencarian
  //         fetchCustomers();
  //       });

  //       return;
  //     }

  //     // Jika input valid, perbarui filterOptions.search
  //     console.log("search", e.target.value);
  //     setFilterOptions((prevState) => ({
  //       ...prevState,
  //       search: e.target.value,
  //     }));
  //   }
  // };

  // const fetchCustomers = useCallback(async () => {
  //   setCustomers((prevState) => ({
  //     ...prevState,
  //     loading: true,
  //   }));

  //   try {
  //     const response = await getRequest(`/customer${queryString}`);
  //     if (response.success) {
  //       setCustomers({
  //         data: response.data,
  //         pagination: response.pagination,
  //         error: null,
  //         loading: false,
  //       });
  //     }
  //   } catch (error) {
  //     setCustomers((prevState) => ({
  //       ...prevState,
  //       error,
  //       loading: false,
  //     }));
  //   }
  // }, [queryString]);

  // Handle search input
  const handleSearch = (e) => {
    if (e.key === "Enter") {
      if (!e.target.value.trim()) {
        // Tampilkan toast jika input kosong
        Swal.fire({
          toast: true,
          position: "top-end",
          icon: "warning",
          title: "Search input cannot be empty!",
          showConfirmButton: false,
          timer: 3000,
          timerProgressBar: true,
        });
        return;
      }

      console.log("search", e.target.value);
      setFilterOptions((prevState) => ({
        ...prevState,
        search: e.target.value,
      }));
    }
  };

  // Fetch customers from API
  const fetchCustomers = useCallback(async () => {
    setCustomers((prevState) => ({
      ...prevState,
      loading: true,
    }));

    try {
      const response = await getRequest(`/customer${queryString}`);
      if (response.success) {
        setCustomers({
          data: response.data,
          pagination: response.pagination,
          error: null,
          loading: false,
        });
      } else {
        console.log("response else", response);
        // Jika API error, tampilkan alert dengan tombol OK
        Swal.fire({
          icon: "error",
          title: "Search Error",
          text: response.message || "Something went wrong during the search.",
          confirmButtonText: "OK",
        }).then(() => {
          // Reload halaman setelah klik OK
          window.location.reload();
        });
      }
    } catch (error) {
      // Tangani error lain seperti koneksi atau server error
      console.log("Failed to fetch customers: ", error);
      Swal.fire({
        icon: "error",
        title: "Search Error",
        text: error.message || "Failed to fetch customers.",
        confirmButtonText: "OK",
      }).then(() => {
        // Reload halaman setelah klik OK
        window.location.reload();
      });
    }
  }, [queryString]);

  useEffect(() => {
    fetchCustomers();
  }, [fetchCustomers]);

  const handlePageChange = (page) => {
    setFilterOptions((prevState) => ({
      ...prevState,
      currentPage: page,
    }));
  };

  const totalPages = customers.pagination?.last_page || 1;

  const Pagination = usePaginationWithComponent({
    totalPages: totalPages,
    currentPage: filterOptions.currentPage,
    onPageChange: handlePageChange,
    visiblePages: 5, // Optional: number of visible pages in pagination (default is 5)
  });

  return (
    <CustomerContext.Provider
      value={{
        customers,
        filterOptions,
        // setFilterOptions,
        handleSearch,
        refetch: fetchCustomers,
        Pagination,
      }}
    >
      {children}
    </CustomerContext.Provider>
  );
};

export const useCustomer = () => {
  const context = useContext(CustomerContext);

  if (!context) {
    throw new Error("useCustomer must be used within CustomerProvider");
  }

  return context;
};
